import { createFileRoute } from "@tanstack/react-router";
import { AccountHome } from "@/components/klantaccount";
import { accountHead } from "@/lib/klantaccount-shared";
export const Route = createFileRoute("/_authenticated/account/")({ head: () => accountHead("Welkom", "Je persoonlijke klantaccount met aanvragen, offertes, facturen en contact met offerto."), component: AccountHome });